import { Box, MenuItem, Select, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useState } from "react";
import { useField } from "react-final-form";

import useRoles from "../../../hooks/useRoles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "150px auto",
    gridGap: 5,
    marginTop: 15,
    marginBottom: 15,
  },
  textStyle: {
    fontSize: 16,
  },
}));

const RoleandBranchInput = ({ required }) => {
  const classes = useStyles();
  const [selectedRole /*setSelectRole*/] = useState();
  const {
    input: { onChange, value },
    meta: { error, touched },
  } = useField("role_id");

  const handleSelect = (e) => {
    onChange(e.target.value);
  };
  return (
    <Box className={classes.container}>
      <Box style={{ display: "flex" }}>
        <Typography className={classes.textStyle}>Role</Typography>
        {required ? (
          <Typography className={classes.textStyle} style={{ color: "orange" }}>
            *
          </Typography>
        ) : null}
      </Box>
      <SelectRole
        value={selectedRole}
        onChange={handleSelect}
        defaultValue={value}
        error={error}
        touched={touched}
      />
    </Box>
  );
};

const SelectRole = ({
  selectedRole,
  defaultValue,
  onChange,
  error: dataError,
  touched,
}) => {
  const { roles, loading, error } = useRoles();
  if (loading) return null;
  if (error) return null;
  return (
    <Box>
      <Select
        defaultValue={defaultValue}
        onChange={onChange}
        value={selectedRole}
        style={{ width: 300 }}
        // fullWidth
      >
        {roles.map((role) => (
          <MenuItem value={role.id}>{role.name}</MenuItem>
        ))}
      </Select>
      {dataError && touched ? (
        <Typography variant="caption" style={{ color: "red" }}>
          {dataError}
        </Typography>
      ) : null}
    </Box>
  );
};

export default RoleandBranchInput;
